import styled from 'styled-components';
import { MediumConfig } from 'modules/frequencyManagement/types';
import { SupportedMediums } from 'modules/frequencyManagement/lib/types';
import { MessageTypesCard } from 'modules/frequencyManagement/components/messageType/MessageTypesCard';
import { FormProvider } from 'modules/frequencyManagement/contexts/FormProvider';
import { EditStateProvider } from 'modules/frequencyManagement/contexts/EditStateProvider';
import { FocusProvider } from 'modules/frequencyManagement/contexts/FocusProvider';
import { MessageMediumCard } from 'modules/frequencyManagement/components/messageMedium/MessageMediumCard';
import { UnsavedChanges } from 'modules/frequencyManagement/components/layout/UnsavedChanges';
import { DiscardChangesModal } from 'modules/frequencyManagement/components/layout/DiscardChangesModal';
import { ManagementSettingsSummaryBanner } from 'modules/frequencyManagement/components/ManagementSettingsSummaryBanner';
import { spacing } from 'ui/theme';
import { Footer } from './Footer';

const Wrapper = styled.div`
  & > *:not(:first-child) {
    margin-top: ${spacing.double};
  }
`;

const BaseFrequencyManagementForm = ({ messageMedium }: { messageMedium: SupportedMediums }) => {
  return (
    <Wrapper>
      <ManagementSettingsSummaryBanner messageMedium={messageMedium} />
      <MessageMediumCard messageMedium={messageMedium} />
      <MessageTypesCard messageMedium={messageMedium} />
      <Footer messageMedium={messageMedium} />
      <UnsavedChanges messageMedium={messageMedium} />
      <DiscardChangesModal />
    </Wrapper>
  );
};

export const FrequencyManagementForm = ({
  mediumConfig,
  messageMedium,
}: {
  mediumConfig: MediumConfig;
  messageMedium: SupportedMediums;
}) => (
  <FormProvider mediumConfig={mediumConfig}>
    <EditStateProvider>
      <FocusProvider>
        <BaseFrequencyManagementForm messageMedium={messageMedium} />
      </FocusProvider>
    </EditStateProvider>
  </FormProvider>
);
